import * as React from 'react';

import { createErrorFunction } from '../utils/TypescriptHelpers';
import { UIActions } from './UIActions';

export const defaultUIActions: UIActions = {
  renderDatabasesActionMenu:
    createErrorFunction('Function of default UIActions context called: renderDatabasesActionMenu'),
  renderTablesActionMenu:
    createErrorFunction('Function of default UIActions context called: renderTablesActionMenu'),
  updateBreadcrumbs:
    createErrorFunction('Function of default UIActions context called: updateBreadcrumbs'),
  updateBreadcrumbHref:
    createErrorFunction('Function of default UIActions context called: updateBreadcrumbHref'),
  setBrowserTitleWithPlaceEntityName:
    createErrorFunction('Function of default UIActions context called: setBrowserTitleWithPlaceEntityName'),
  setBrowserTitleWithPlaceNameFunction:
    createErrorFunction('Function of default UIActions context called: setBrowserTitleWithPlaceNameFunction'),
  setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName:
    createErrorFunction('Function of default UIActions context called: setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName'),
  popToast:
    createErrorFunction('Function of default UIActions context called: popToast'),
  closeToast:
    createErrorFunction('Function of default UIActions context called: closeToast'),
  sendNavigationTelemetryEvent:
    createErrorFunction('Function of default UIActions context called: sendNavigationTelemetryEvent'),
  maybeSendDataQualitySubscriptionEvent:
    createErrorFunction('Function of default UIActions context called: maybeSendDataQualitySubscriptionEvent'),
};

export const UIActionsContext = React.createContext<UIActions>(defaultUIActions);
